import { Grid, MenuProps } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "../../context/useLocalStorage";
import localStorageKey from "../../enumerations/localStorageKey";
import { pushGtag } from "../../plugins/utils";
import { P1 } from "../NormalFonts";
import { LanguageContainer } from "./components";
import { LanguageDropdownProps, LanguageResponse } from "./data";
import { useGetLanguage } from "./language.hooks";
import styles from "./styles.module.scss";

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  showDrawer,
  setShowDrawer,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [defaultLanguage, setDefaultLanguage] = useLocalStorage(
    localStorageKey.DEFAULT_LANG,
    "zh-TW"
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { data: languages } = useGetLanguage({
    enabled: isOpen === true || showDrawer === true,
  });
  const [languageDropdown, setLanguageDropdown] = useState<LanguageResponse[]>(
    []
  );

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
  };

  const onClick: MenuProps["onClick"] = ({ key }) => {
    setLanguage(key);
  };

  const setLanguage = (code: string) => {
    pushGtag({
      event: "change_language",
      code,
    });

    setDefaultLanguage(code);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  useEffect(() => {
    if (!languages) return;
    setLanguageDropdown(
      languages?.map((lang: LanguageResponse) => {
        return {
          ...lang,
          key: lang.code,
          label: (
            <div
              key={lang.code}
              className={`${styles.menuitem} ${
                defaultLanguage === lang.code ? styles.active : ""
              }`}
            >
              <P1 color="var(--Neutral-dark-70)">
                {t(`language.${lang.code}`)}
              </P1>
            </div>
          ),
          type: "item", // Ensure the type property is added
        };
      })
    );
  }, [languages]);

  const onClose = () => {
    setShowDrawer(false);
  };

  const renderLanguageList = () => {
    if (!languages) return null;
    return languages.map((lang: LanguageResponse, index: number) => {
      return (
        <P1
          key={index}
          className={styles.link}
          onClick={() => {
            setLanguage(lang.code);
          }}
        >
          {t(`language.${lang.code}`)}
        </P1>
      );
    });
  };

  return (
    <LanguageContainer
      languageDropdown={languageDropdown}
      onClick={onClick}
      handleOpenChange={handleOpenChange}
      setShowDrawer={setShowDrawer}
      onClose={onClose}
      showDrawer={showDrawer}
      renderLanguageList={renderLanguageList}
    />
  );
};

export default LanguageDropdown;
